import { render, staticRenderFns } from "./PesquisaPacienteModal.vue?vue&type=template&id=5f709c37&scoped=true"
import script from "./PesquisaPacienteModal.vue?vue&type=script&lang=js"
export * from "./PesquisaPacienteModal.vue?vue&type=script&lang=js"
import style0 from "./PesquisaPacienteModal.vue?vue&type=style&index=0&id=5f709c37&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f709c37",
  null
  
)

export default component.exports